import ContainedButton from "components/layout/form/containedButton";
import React from "react";
import { MdClose } from "react-icons/md";

import bill from "assets/images/boleto-consumo-gas.png";

import { Body, Container, Content, Footer, Header, Img, Style } from "./styles";

const ModalBill = ({ open, toggleModal }: any): JSX.Element => {
  return (
    <Style show={open} centered animation={false}>
      <Container>
        <Header>
          <div className="wrapper">
            <span>Seu Boleto</span>
          </div>
          <MdClose size={24} onClick={toggleModal} />
        </Header>
        <Body>
          <Content>
            <Img src={bill} alt="Consulta Boleto Físico" />
          </Content>
        </Body>
        <Footer>
          <ContainedButton onClick={toggleModal}>Ok</ContainedButton>
        </Footer>
      </Container>
    </Style>
  );
};

export default ModalBill;
